export var ClientEvent;
(function (ClientEvent) {
    ClientEvent["CollectionSubscribe"] = "subscribe:collection";
    ClientEvent["CollectionUnsubscribe"] = "unsubscribe:collection";
    ClientEvent["NftSubscribe"] = "subscribe:nft";
    ClientEvent["NftUnsubscribe"] = "unsubscribe:nft";
    ClientEvent["UserSubscribe"] = "subscribe:user";
    ClientEvent["UserUnsubscribe"] = "unsubscribe:user";
})(ClientEvent || (ClientEvent = {}));
export var ServerEvent;
(function (ServerEvent) {
    ServerEvent["OrderNew"] = "order:new";
    ServerEvent["OrderStatus"] = "order:status";
    ServerEvent["SaleNew"] = "sale:new";
    ServerEvent["UserOrderUpdate"] = "user:order-update";
    ServerEvent["Unauthorized"] = "unauthorized";
})(ServerEvent || (ServerEvent = {}));
export const buildCollectionRoom = (network, contractAddress) => `collection:${network}:${contractAddress.toLowerCase()}`;
export const buildNftRoom = (network, contractAddress, tokenId) => `nft:${network}:${contractAddress.toLowerCase()}:${tokenId}`;
export const buildUserRoom = (delugeId) => `user:${delugeId}`;
//# sourceMappingURL=index.js.map